enum CalendarDictionariesAction {
  FETCH_CALENDAR_DICTIONARIES = 'calendarDicitonaries/fetchAll'
}

export default CalendarDictionariesAction;
